import { isToday, isYesterday } from 'date-fns';
import { useTranslation } from 'react-i18next';

import {
  Notification,
  NotificationContentCategory,
  NotificationContentType,
  NotificationGroup,
  NotificationType,
} from '@/features/notifications/notification-types';
import { formatDate } from '@/shared/utils/format';

export const groupNotifications = (
  notifications: Notification[],
): NotificationGroup[] =>
  Object.entries(
    notifications.reduce(
      (acc, notification) => {
        const timestamp = notification.created_at;
        if (!timestamp) return acc;
        const date = new Date(timestamp).toISOString().split('T')[0];
        (acc[date] ??= []).push(notification);
        return acc;
      },
      {} as Record<string, Notification[]>,
    ),
  )
    .map(([date, notifications]) => ({ date, notifications }))
    .sort((a, b) => new Date(b.date).getTime() - new Date(a.date).getTime());

export const formatGroupDate = (dateStr: string) => {
  const { t } = useTranslation('shared');
  const date = new Date(dateStr);
  if (isToday(date)) {
    return t('today');
  }
  if (isYesterday(date)) {
    return t('yesterday');
  }
  return formatDate({
    date,
    formatType: 'digits',
  });
};

export const getNotificationContentTypeString = (
  type: NotificationContentType,
) => {
  const { t } = useTranslation('notification', { keyPrefix: 'ContentTypes' });
  return t(`${type}`);
};

export const getNotificationTypeString = (type: NotificationType) => {
  const { t } = useTranslation('notification', {
    keyPrefix: 'NotificationTypes',
  });
  return t(`${type}`);
};

export const getNotificationContentCategoryString = (
  category: NotificationContentCategory,
) => {
  const { t } = useTranslation('notification', {
    keyPrefix: 'ContentCategories',
  });
  return t(`${category}`);
};
